var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewselaMarkReducedsizeRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 1 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.8 33.2h32.5V.7H.8v32.5zm15.1-5.1h-10V5.9h10v22.2zm12.2 0h-10V5.9H23c2.8 0 5.1 2.3 5.1 5.1v17.1z",
    fill: "#0A6EFA",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg viewBox='1 1 32 32' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg fill='%230A6EFA' fill-rule='nonzero'%3E %3Cpath d='M0.8,33.2 L33.3,33.2 L33.3,0.7 L0.8,0.7 L0.8,33.2 Z M15.9,28.1 L5.9,28.1 L5.9,5.9 L15.9,5.9 L15.9,28.1 Z M28.1,28.1 L18.1,28.1 L18.1,5.9 L23,5.9 C25.8,5.9 28.1,8.2 28.1,11 L28.1,28.1 Z' id='Shape'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgNewselaMarkReducedsizeRgb as ReactComponent };